function getFreshTransientUiState() {
  return {
    errors: {},
    addressSuggestions: [],
    isCheckingPhone: false,
  };
}

module.exports = {
  getFreshTransientUiState,
};
